import { createSelector } from 'reselect';

export const getMetrics = createSelector(state => state.Metrics, r => r);